import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["locale", "supportTwYearFormat", "t", "disablePortal"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ButtonDatePicker } from "../chunk-ZTYEUCXT.mjs";
import "../chunk-HLF6VBAG.mjs"; // src/TwDatePicker/index.tsx

import { ThemeProvider, createTheme } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import tMoment from "moment-taiwan";
import "moment/locale/zh-cn";
import "moment/locale/zh-tw";
import { useCallback, useMemo, useState } from "react";
import { jsx } from "react/jsx-runtime";
var theme = createTheme({
  palette: {
    primary: {
      main: "#EB901D",
      light: "#ffb964",
      dark: "#EB901D"
    }
  },
  components: {
    MuiPickersPopper: {
      styleOverrides: {
        root: function root(_ref) {
          var ownerState = _ref.ownerState,
              theme2 = _ref.theme;
          return {
            width: 280,
            height: 360,
            borderRadius: "".concat(theme2.shape.borderRadius, "px")
          };
        },
        paper: {
          boxShadow: "none"
        }
      }
    },
    MuiPickersLayout: {
      styleOverrides: {
        root: function root(_ref2) {
          var ownerState = _ref2.ownerState,
              theme2 = _ref2.theme;
          return {
            boxShadow: theme2.shadows[4]
          };
        }
      }
    },
    MuiPickersYear: {
      styleOverrides: {
        yearButton: function yearButton(_ref3) {
          var ownerState = _ref3.ownerState,
              theme2 = _ref3.theme;
          return {
            "&.Mui-selected": {
              color: theme2.palette.white
            }
          };
        }
      }
    },
    MuiDateCalendar: {
      styleOverrides: {
        root: {
          width: "100%",
          height: 290
        }
      }
    },
    MuiYearCalendar: {
      styleOverrides: {
        root: {
          width: "100%",
          justifyContent: "center"
        }
      }
    },
    MuiPickersDay: {
      styleOverrides: {
        root: function root(_ref4) {
          var ownerState = _ref4.ownerState,
              theme2 = _ref4.theme;
          return {
            width: "2rem",
            height: "2rem",
            lineHeight: "1rem",
            fontSize: theme2.typography.button.fontSize,
            color: theme2.palette.grey.A700,
            "&:hover": {
              backgroundColor: theme2.palette.grey.A100
            },
            "&.Mui-selected": {
              color: theme2.palette.grey.A700,
              border: "1px solid ".concat(theme2.palette.primary.main),
              backgroundColor: "white",
              fontWeight: theme2.typography.fontWeightMedium
            },
            "&:focus.Mui-selected": {
              backgroundColor: "white"
            }
          };
        }
      }
    },
    MuiDayCalendar: {
      styleOverrides: {
        weekDayLabel: {
          width: "2rem",
          height: "2rem"
        }
      }
    }
  }
});

var TwDatePicker = function TwDatePicker(_ref5) {
  var locale = _ref5.locale,
      supportTwYearFormat = _ref5.supportTwYearFormat,
      t = _ref5.t,
      disablePortal = _ref5.disablePortal,
      rest = _objectWithoutProperties(_ref5, _excluded);

  var _useState = useState(locale === "zh-tw"),
      isTwYearFormat = _useState[0],
      setIsTwYearFormat = _useState[1];

  var toggleYearFormat = useCallback(function (e) {
    var _e$nativeEvent;

    setIsTwYearFormat(function (prev) {
      return !prev;
    });
    e.stopPropagation();
    (_e$nativeEvent = e.nativeEvent) === null || _e$nativeEvent === void 0 ? void 0 : _e$nativeEvent.stopImmediatePropagation();
  }, []);
  var dateFormats = useMemo(function () {
    return {
      year: isTwYearFormat ? "tYY\u5E74" : "YYYY",
      monthAndYear: isTwYearFormat ? "MMM tYY\u5E74" : "MMM YYYY",
      weekdayShort: "dd",
      fullDate: isTwYearFormat ? "tYY-MM-DD" : "YYYY-MM-DD"
    };
  }, [isTwYearFormat]);
  return /* @__PURE__ */jsx(ThemeProvider, {
    theme: theme,
    children: /* @__PURE__ */jsx(LocalizationProvider, {
      adapterLocale: locale,
      dateAdapter: AdapterMoment,
      dateLibInstance: tMoment,
      dateFormats: dateFormats,
      children: /* @__PURE__ */jsx(ButtonDatePicker, _objectSpread({
        supportTwYearFormat: supportTwYearFormat,
        toggleYearFormat: toggleYearFormat,
        locale: locale,
        disablePortal: disablePortal,
        t: t
      }, rest))
    })
  });
};

export { TwDatePicker };